export default {
    monitor: {name: "Monitor"},
    keyboard: {name: "Klaviatur"},
    mouse: {name: "Maus"},
    webcam: {name: "Webcam"},
    headset: {name: "Headset"},
    dockingStation: {name: "Dockingstation"},
}